const octoAsync = async function (currUrl, currMethod, currHeaders, currData = ''){
    let response;
    if (currData !== '') {
        response = await fetch(`${currUrl}`, {
            method: currMethod,
            body: JSON.stringify(currData),
            headers: currHeaders,
        })
    }else {
        response = await fetch(`${currUrl}`, {
            method: currMethod,
            headers: currHeaders
        })
    }
    const responseJSON = await response.json()
    return responseJSON
}

var currDataFull;
var productSelected;
var productComplementary;
var currentDiscount = 0;
var currntBundlesCreated = [];
var numBundles = 0;


function removeCurrentProductSelected(){
    $(".custom-bundles__content__right__add-bundle__content").addClass("no-selected");
    $(".custom-bundles__content__right__add-bundle__content").removeAttr("data-image");
    $(".custom-bundles__content__right__add-bundle__content").removeAttr("data-varint-id");
    $(".custom-bundles__content__right__add-bundle__content").removeAttr("data-price");
    $(".custom-bundles__content__right__add-bundle__content").removeAttr("data-name");
    $(".custom-bundles__content__right__add-bundle__content img").attr("src", "https://cdn.shopify.com/s/files/1/0517/2641/8073/files/Component_1.webp?v=1765912461");
    $(".custom-bundles__content__right__add-bundle__content.closure p").text(`CHOOSE CLOSURE`);
    $(".custom-bundles__content__right__add-bundle__content.bottle p").text(`CHOOSE BOTTLE`);
    $(".custom-bundles__content__right__add-bundle__content > div div").text(``);
    $(".custom-bundles__content__right__add-bundle__content span").text(``);
    $(".custom-bundel-price").text(``).removeClass("active");
    $(".cutom-bundle-span").removeClass("active");
    $(".custom-button-add-to-bundle").removeClass("active");

    $(".step-custom__content__product__details-add-add").removeClass("current-added");
    if(productSelected){
        if(productSelected[0].inventory_quantity > 0){
            $(".step-custom__content__product__details-add-add").prop('disabled', false);
            $(".step-custom__content__product__details-add-add").text('ADD TO BUNDLE');
        }else{
            $(".step-custom__content__product__details-add-add").prop('disabled', true);
            $(".step-custom__content__product__details-add-add").text('OUT OF STOCK');
        }
    }else{
        $(".step-custom__content__product__details-add-add").prop('disabled', false);
        $(".step-custom__content__product__details-add-add").text('ADD TO BUNDLE');
    }
   
   
}

const getAllData = async function (currID, currProducts = 0) {
    
    $(".step-custom__content__product__details__colors").html(``);
    $(".step-custom__content__product__details__sizes").html(``);
    $(".step-custom__content__product__details__current-color").html(``);
    $(".step-custom__content__product__image").html(``);
    $(".step-custom__content__product__details-title").html(``);
    $(".step-custom__content__product__details__current-units-per-box").html(``);
    $(".step-custom__content__product__details-add-price").html(``);
    $(".step-custom__content__product__details-add-add").hide();
    $(".step-custom__content__selects.types").html("");
    $("#slider-related-bundles .owl-carousel").html("");
    
    removeCurrentProductSelected();
    try{
        let headers = {}
        let response = await octoAsync(`/apps/get_catalog?catalog_id=${currID}&type=bundle`, `GET`, headers);
        let productsColors = response?.colors;
        currDataFull = productsColors;
        let templateColors = ``;
        if(productsColors){
            Object.keys(productsColors).forEach((key, index)=> {
                templateColors += `<a class="octo-option-item-color" data-key="${productsColors[key]}" data-color="${productsColors[key].color}">
                 <span option-label="#c27834" class="color" style="background-color: ${productsColors[key].colorhex};"> </span>
                </a>`;
            });
        }
        if(response.status === `error` ){}else{
            $(".step-custom__content__product__details__colors").html(templateColors);
            $(".step-custom__content__product__details__colors .octo-option-item-color:first-child").trigger("click");
            
        }
    }catch(error){
        console.log(error)
    }
}

const getAllDataChange = async function (currDataFull, currentColor) {
    $(".step-custom__content__product__details__current-color").html(currentColor);
    let getCurrentSize = $(".octo-option-item-size.active").attr("data-size");
    removeCurrentProductSelected();
    if(currDataFull){
        const getColorObject = (data, colorName) => {
            return data.find(item => item.color === colorName);
        };
        const currentProducts = getColorObject(currDataFull, currentColor);
        let productsFromColor = currentProducts?.products;
        const productsFromColorSizes = productsFromColor.map(item => item.size);
        let templateSizes = ``;

        for (let i = 0; i < productsFromColorSizes.length; i++) {
            templateSizes += `<a class="octo-option-item-size"  data-size="${productsFromColorSizes[i]}">
                ${productsFromColorSizes[i]}
            </a>`;
        }
       
        $(".step-custom__content__product__details__sizes").html(templateSizes);
        if($(`.step-custom__content__product__details__sizes .octo-option-item-size[data-size="${getCurrentSize}"]`).length > 0){
            $(`.step-custom__content__product__details__sizes .octo-option-item-size[data-size="${getCurrentSize}"]`).trigger("click")
        }else{
            $(".step-custom__content__product__details__sizes .octo-option-item-size:first-child").trigger("click");
        }
    }
}

const getAllDataChangeSize = async function (currDataFull, currentColor, currentSize) {
    $(".step-custom__content__product__details__current-color").html(currentColor);
    removeCurrentProductSelected();
    if(currDataFull){
        const getColorObject = (data, colorName) => {
            return data.find(item => item.color === colorName);
        };
        const currentProducts = getColorObject(currDataFull, currentColor);
        const currentProduct = currentProducts.products.filter(item => item.size === currentSize);
        const uniqueTypes = currentProduct[0]?.accesories ? [...new Set(currentProduct[0].accesories.map(i => i.product_type))] : [];
        let templateTypes = ``;
        for (let i = 0; i < uniqueTypes.length; i++) {
            templateTypes += `<a class="custom-select-button type" data-type="${uniqueTypes[i]}">
                ${uniqueTypes[i]}
            </a>`;
        }
        productSelected = currentProduct;
        console.log(currentProduct)
        console.log(currentProduct[0].inventory_quantity)
        if(currentProduct){
            $(".step-custom__content__product__image").html(`<img src="${currentProduct[0].feature_image_url}" alt="${currentProduct[0].product_name}" />`);
            $(".step-custom__content__product__details-title").html(`${currentProduct[0].product_name}`);
            $(".step-custom__content__product__details__current-units-per-box").html(`
                <div class="select-bundle ">
                    <select  class="select__select" name="options[Quantity]" >
                        <option value="${currentProduct[0].bottles_by_box}" selected="selected">
                            ${currentProduct[0].bottles_by_box}
                        </option>
                    </select>
                    <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
                    </path></svg>
                </div>`);
            $(".step-custom__content__product__details-add-price").html(`$${currentProduct[0].price}`);
            $(".step-custom__content__product__details-add-add").show();
            $(".step-custom__content__product__details-add-add").attr("data-variant-id", currentProduct[0].variant_id);
            if(currentProduct[0].inventory_quantity <= 0){
                $('.step-custom__content__product__details-add-add').prop('disabled', true);
                $('.step-custom__content__product__details-add-add').text('OUT OF STOCK');
            }else{
                $('.step-custom__content__product__details-add-add').prop('disabled', false);
                $('.step-custom__content__product__details-add-add').text('ADD TO BUNDLE');
            }
        }
        if(uniqueTypes){
            $(".step-custom__content__selects.types").html(templateTypes);
            $(".step-custom__content__selects.types .custom-select-button:first-child").trigger("click");
        }
    }
}

function equalizeOwlHeights($carousel) {
    let maxHeight = 0;

    $carousel.find('.owl-item .item').each(function () {
        maxHeight = Math.max(maxHeight, $(this).outerHeight());
    });

    $carousel.find('.owl-item .item').height(maxHeight);
}

const getAllDataChangeType = async function (productsAccesories, currType) {
    $('#slider-related-bundles .owl-carousel').owlCarousel('destroy'); 
    $('#slider-related-bundles .owl-carousel').owlCarousel({touchDrag: false, mouseDrag: false});
    $("#slider-related-bundles .owl-carousel").trigger("destroy.owl.carousel");
    $("#slider-related-bundles .owl-carousel").hide();
    $("#slider-related-bundles .owl-carousel").html("");
    $("#slider-related-bundles > span").addClass("active");
    const filteredItems = productsAccesories.filter(
        item => item.product_type === currType
    );
    let templeteProductSlider = ``;

    
    
    Object.keys(filteredItems).forEach((key, index)=> {
        let buttonAddAccesorie  = `<button class="step-custom__content__product__details-add-add-accesorie" 
            data-variant-id="${filteredItems[key].variant_id}" 
            ${filteredItems[key].inventory_quantity <= 0 ? "disabled": ""}>ADD TO BUNDLE
        </button>`;

        if(filteredItems[key].inventory_quantity < 1){
            buttonAddAccesorie = `<button class="step-custom__content__product__details-add-add-accesorie" 
                data-variant-id="${filteredItems[key].variant_id}" 
                ${filteredItems[key].inventory_quantity <= 0 ? "disabled": ""}>OUT OF STOCK
            </button>`;
        }
        templeteProductSlider += `<div class="item" ${filteredItems[key].inventory_quantity <= 0 ? "disabled": ""}>
            <img src="${filteredItems[key].image_src}" alt="${filteredItems[key].title}" width="" height="" />
            <p class="step-custom__content__product__details-add-add-title">${filteredItems[key].title}</p>
            <div class="step-custom__content__product__details-add-price-accesorie">$${filteredItems[key].price}</div>
            ${buttonAddAccesorie}
        </div>`;
    });

    $("#slider-related-bundles .owl-carousel").append(templeteProductSlider);
    $("#slider-related-bundles .owl-carousel").addClass("loading-caroucel");

    setTimeout(() => {
        const $c = $('#slider-related-bundles .owl-carousel');

        // Por si ya estaba inicializado
        if ($c.hasClass('owl-loaded')) {
            $c.trigger('destroy.owl.carousel');
            $c.removeClass('owl-loaded');
            $c.find('.owl-stage-outer').children().unwrap();
        }

        $c.owlCarousel({
            loop: false,
            margin: 0,
            responsiveClass: true,
            autoHeight: false,
            nav: true,
            smartSpeed: 1000,
            center:false,
            touchDrag:true,
            autoplay:false,
            autoplayTimeout:5000,
            navText : [
            `<img src="https://cdn.shopify.com/s/files/1/0517/2641/8073/files/ChevronArr.png?v=1706810525" alt="left" />`,
            `<img src="https://cdn.shopify.com/s/files/1/0517/2641/8073/files/ChevronArr.png?v=1706810525" alt="right" />`
            ],
            onInitialized: function () {
                $c.fadeIn(0, () => $c.trigger('refresh.owl.carousel'));
            },
            responsive: {
                300:  { items: 2},
                1000: { items: 2 },
                1200: { items: 3 }
            }
        });
        
    }, 100);

    setTimeout(() => {
        $("#slider-related-bundles > span").removeClass("active");
        $("#slider-related-bundles .owl-carousel").removeClass("loading-caroucel");
    }, 1000);
    
}

const calculatePricesPreBundle = function(currEvent = "none"){
    let firstPrice = 0;
    let secondPrice = 0;
    let countItems = 0
    $('.custom-bundles__content__right__add-bundle__content').each(function (index) {
        if(Number($(this).attr("data-price"))){
            firstPrice += Number($(this).attr("data-price"));
            countItems++;
        }
    });
    if(countItems == 2){

        currentDiscount = currentDiscount || 0;
        let secondPrice = Number((firstPrice * (1 - currentDiscount  / 100)).toFixed(2));

        if($(window).width() < 950){
            $('.custom-bundles__content__right.mobile').addClass('active');
            $(".view-my-bundles").text("Create new bundle");
            setTimeout(scrollToTopIfActive, 50);
        }
        
        $(".cutom-bundle-span").removeClass("active");
        $(".custom-bundel-price.first-price").text(``).removeClass("active");
        $(".custom-bundel-price.second-price").text(``).removeClass("active");
        $(".custom-button-add-to-bundle").text(``).removeClass("active");
        if(firstPrice !== secondPrice){
            $(".cutom-bundle-span").addClass("active");
            $(".custom-bundel-price.first-price").text(`$${secondPrice.toFixed(2)}`).addClass("active");
            $(".custom-bundel-price.second-price").text(`$${firstPrice.toFixed(2)}`).addClass("active");
            $(".custom-button-add-to-bundle").text(`ADD BUNDLE TO CART`).addClass("active");
        }else{
            $(".cutom-bundle-span").addClass("active");
            $(".custom-bundel-price.first-price").text(`$${firstPrice.toFixed(2)}`).addClass("active");
            $(".custom-button-add-to-bundle").text(`ADD BUNDLE TO CART`).addClass("active");
        }
    }
    
}

function getDotRefX(el, index, total) {
  const rect = el.getBoundingClientRect();

  if (index === 0) return rect.left;
  if (index === total - 1) return rect.right;
  return rect.left + rect.width / 2;
}

function updateItems(currEvent){

    numBundles = currntBundlesCreated.length;

    let targetIndex = 0; 
    let currentDiscountFinal = Number($(`.custom-bundles__content__right__bar--line span:last-child`).attr("data-discount"));
    let currentBundlesForAdd = ``;
  
    if(numBundles > discountBlocksCount){
        $(".custom-bundles__content__right__title span").text(discountBlocksCount);
        $(".custom-bundles__content__right__subtitle span").text(0);
        $(`.custom-bundles__content__right__bar--line span:nth-child(${discountBlocksCount})`).attr("");
        currentDiscount = Number($(`.custom-bundles__content__right__bar--line span:nth-child(${discountBlocksCount})`).attr("data-discount"));
        targetIndex = discountBlocksCount - 1;
        currentBundlesForAdd = `YOUR DISCOUNT ${currentDiscountFinal}%OFF`;
    }else{
        $(".custom-bundles__content__right__title span").text(numBundles);
        $(".custom-bundles__content__right__subtitle span").text(discountBlocksCount - numBundles);
        currentDiscount = Number($(`.custom-bundles__content__right__bar--line span:nth-child(${numBundles})`).attr("data-discount"));
        targetIndex = numBundles - 1;
        if(numBundles == discountBlocksCount){
            currentBundlesForAdd = `YOUR DISCOUNT ${currentDiscountFinal}%OFF`;
        }else{
            currentBundlesForAdd = `ADD ${discountBlocksCount - numBundles} CUSTOM BUNDLE FOR ${currentDiscountFinal}%OFF`;
        }
        
    }

    targetIndex = targetIndex == -1 ? 0 : targetIndex;

    calculatePricesPreBundle(currEvent);

    const spans = document.querySelectorAll(
        '.custom-bundles__content__right__bar--line span'
    );

    const totalSpans = spans.length;
    const isLast = targetIndex === totalSpans - 1;

    let widthValue;
    let extra = targetIndex !== 0 ? 3 : 0;

    if(isLast){
        widthValue = '100%';
        $('.custom-bundles__content__right__bar--content-purple').addClass("full");
    }else{
        const startX  = getDotRefX(spans[0], 0, totalSpans);
        const targetX = getDotRefX(spans[targetIndex], targetIndex, totalSpans);
        widthValue = `${(targetX - startX) + extra}px`;
        $('.custom-bundles__content__right__bar--content-purple').removeClass("full");
        
    }
    
    $('.custom-bundles__content__right__bar--content-purple').css('width', widthValue);

    if(numBundles > 0){
        $(".custom-bundeles-cart__title").addClass("active");
        $(".custom-bundeles-cart__title span").text(`(${numBundles})`);
    }else {
        $(".custom-bundeles-cart__title").removeClass("active");
        $(".custom-bundeles-cart__title span").text("");
    }

    $(".custom-bundeles-cart__items").html("");
    let templateItems = ``;

    Object.keys(currntBundlesCreated).forEach((key, index)=> {

        let priceBottle = Number(currntBundlesCreated[key].currBottle.price);
        let priceClusure = Number(currntBundlesCreated[key].currClosure.price);

        let firstPrice2 = priceBottle + priceClusure;

        let secondPrice2 = Number((firstPrice2 * (1 - currentDiscount / 100)).toFixed(2));
        let templatePrices = ``;
        if(firstPrice2 != secondPrice2){
            templatePrices = `
                <span class="custom-bundel-price_c cart_first-price">$${secondPrice2.toFixed(2)} </span>
                <span class="custom-bundel-price_c cart_second-price"> $${firstPrice2.toFixed(2)}</span>
            `;
        }else{
            templatePrices = `
                <span class="custom-bundel-price_c cart_first-price">$${firstPrice2.toFixed(2)}</span>
            `;
        }
        
        templateItems += `
            <div class="custom-bundeles-cart__items-item" data-index="${index}">
                <div class="custom-bundeles-cart__items-item-left">
                    <a class="img-tooltip bottle" title="${currntBundlesCreated[key].currBottle.title}">
                    <img src="${currntBundlesCreated[key].currBottle.img}" alt="${currntBundlesCreated[key].currBottle.title}" />
                    </a>
                    <img src="https://cdn.shopify.com/s/files/1/0517/2641/8073/files/plus-purple.webp?v=1766002182" />
                    <a class="img-tooltip closure" title="${currntBundlesCreated[key].currClosure.title}">
                    <img src="${currntBundlesCreated[key].currClosure.img}"/>
                    </a>
                </div>
                <div class="custom-bundeles-cart__items-item-right">
                    <span class="cutom-bundle-span_c cart">CUSTOM BUNDLE</span>
                    ${templatePrices}
                    <button class="remove-bundle-from-cart" data-index="${index}">REMOVE</button>
                </div>
            </div>`;
    });

    $(".custom-bundeles-cart__items").html(templateItems);

    $(".custom-bundles__footer").html("");
    let templateBundleFooter = ``;
    let priceNormalFull = 0;
    let priceDiscountFull = 0;
    let priceFinal = 0;
    Object.keys(currntBundlesCreated).forEach((key, index)=> {
        let priceBottleP = Number(currntBundlesCreated[key].currBottle.price);
        let priceClusureP = Number(currntBundlesCreated[key].currClosure.price);

        let priceNormal = (priceBottleP + priceClusureP);
        let priceDiscount = Number((priceNormal * (1 - currentDiscount / 100)).toFixed(2));

        priceNormalFull += priceNormal;
        priceDiscountFull +=  priceDiscount;
    });

    $(".btn-checkut").removeClass("active");
    $(".btn-checkut").text("");
    $(".btn-checkut").attr("href", "");
    if(numBundles > 0){
        let url = buildCartUrlFromBundles(currntBundlesCreated);
        $(".btn-checkut").addClass("active");
        $(".btn-checkut").text(`PROCEED TO CART ($${priceDiscountFull.toFixed(2)})`);
        $(".btn-checkut").attr("href", url);
        if(priceNormalFull != priceDiscountFull){
            templateBundleFooter = `
                <div class="custom-bundles__footer__save">
                    <div class="custom-bundles__footer__save-text">
                        YOU SAVE
                    </div>
                    <div class="custom-bundles__footer__save-discount">
                        $${(priceNormalFull - priceDiscountFull).toFixed(2)}(${currentDiscount}%OFF)
                    </div>
                </div>
                <a href="${url}">PROCEED TO CART ($${priceDiscountFull.toFixed(2)})</a>
                <p class="custom-bundles__footer__add-more">${currentBundlesForAdd}</p>`;
                
        }else{
            templateBundleFooter = `
                <a href="${url}">PROCEED TO CART ($${priceDiscountFull.toFixed(2)})</a>
                <p class="custom-bundles__footer__add-more">${currentBundlesForAdd}</p>`;
        }
        $(".custom-bundles__footer").html(templateBundleFooter);
    }

}

function buildCartUrlFromBundles(currntBundlesCreated, domain = "https://bottledepot.myshopify.com", channel = "buy_button") {
  const qtyByVariant = {};

  currntBundlesCreated.forEach((bundle) => {
    const bottleId = String(bundle?.currBottle?.variant_id || "").trim();
    const closureId = String(bundle?.currClosure?.variant_id || "").trim();

    if (bottleId) qtyByVariant[bottleId] = (qtyByVariant[bottleId] || 0) + 1;
    if (closureId) qtyByVariant[closureId] = (qtyByVariant[closureId] || 0) + 1;
  });

  const itemsStr = Object.entries(qtyByVariant)
    .map(([id, qty]) => `${id}:${qty}`)
    .join(",");

  if (!itemsStr) return `${domain}/cart?channel=${encodeURIComponent(channel)}`;

  return `${domain}/cart/${itemsStr}?channel=${encodeURIComponent(channel)}`;
}


async function addBundlesToCartAndGo(currntBundlesCreated) {
  const bundles = Array.isArray(currntBundlesCreated) ? currntBundlesCreated : [];

  // ---------- helpers ----------
  const variantCache = new Map();

  const getVariantInfo = async (variantId) => {
    const id = String(variantId || "").trim();
    if (!id) return null;
    if (variantCache.has(id)) return variantCache.get(id);

    try {
      const res = await fetch(`/variants/${encodeURIComponent(id)}.js`, {
        method: "GET",
        headers: { Accept: "application/json" },
        cache: "no-store",
      });
      if (!res.ok) {
        variantCache.set(id, null);
        return null;
      }

      const v = await res.json();
      const info = {
        id,
        title: v?.name || v?.title || `Variant ${id}`,
        available: Boolean(v?.available),
        inventory_quantity: typeof v?.inventory_quantity === "number" ? v.inventory_quantity : null,
        inventory_policy: v?.inventory_policy || null,        // "deny" | "continue"
        inventory_management: v?.inventory_management || null // "shopify" | null
      };

      variantCache.set(id, info);
      return info;
    } catch (e) {
      variantCache.set(id, null);
      return null;
    }
  };

  // vendible: si no controla inventario o "continue" => infinito
  const sellableQty = (info) => {
    if (!info || !info.available) return 0;

    const unmanaged = !info.inventory_management;
    const canContinue = info.inventory_policy === "continue";
    if (unmanaged || canContinue) return Number.POSITIVE_INFINITY;

    if (typeof info.inventory_quantity === "number") return Math.max(0, info.inventory_quantity);

    // si no viene inventory_quantity pero está available, trátalo como “unknown” => infinito
    return Number.POSITIVE_INFINITY;
  };

  const addTwoAsBundle = async (bottleId, closureId) => {
    // IMPORTANT: agregamos los 2 en el MISMO request
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: [
          { id: Number(bottleId), quantity: 1, properties: { bundle: "bundle" } },
          { id: Number(closureId), quantity: 1, properties: { bundle: "bundle" } },
        ],
      }),
    });
  };

  // ---------- 1) precarga inventarios de variants involucrados ----------
  const ids = new Set();
  for (const b of bundles) {
    const bottleId = String(b?.currBottle?.variant_id || "").trim();
    const closureId = String(b?.currClosure?.variant_id || "").trim();
    if (bottleId) ids.add(bottleId);
    if (closureId) ids.add(closureId);
  }

  const infosArr = await Promise.all([...ids].map(getVariantInfo));
  const infoById = {};
  for (const info of infosArr) if (info?.id) infoById[info.id] = info;

  // stock objetivo (vendible) por variant
  const maxByVariant = {};
  for (const id of ids) maxByVariant[id] = sellableQty(infoById[id]);

  // contador de lo que YA llevas agregado en ESTA ejecución
  const addedByVariant = {}; // id => qty
  const removed = [];        // mensajes

  // ---------- 2) paquete por paquete ----------
  for (const b of bundles) {
    const bottleId = String(b?.currBottle?.variant_id || "").trim();
    const closureId = String(b?.currClosure?.variant_id || "").trim();
    if (!bottleId || !closureId) continue;

    const bottleTitle = infoById[bottleId]?.title || b?.currBottle?.title || `Variant ${bottleId}`;
    const closureTitle = infoById[closureId]?.title || b?.currClosure?.title || `Variant ${closureId}`;

    const bottleMax = maxByVariant[bottleId] ?? 0;
    const closureMax = maxByVariant[closureId] ?? 0;

    const bottleAdded = addedByVariant[bottleId] || 0;
    const closureAdded = addedByVariant[closureId] || 0;

    const bottleCan = bottleMax === Infinity ? true : (bottleAdded + 1) <= bottleMax;
    const closureCan = closureMax === Infinity ? true : (closureAdded + 1) <= closureMax;

    // si uno no puede, NO agregamos nada (mantiene pares)
    if (!bottleCan || !closureCan) {
        const reason =
            !bottleCan && !closureCan
            ? "insufficient stock (main item and accessory)"
            : !bottleCan
                ? "insufficient stock for the main item"
                : "insufficient stock for the accessory";

        removed.push(
            `- 1 bundle "${bottleTitle}" + "${closureTitle}" was removed (${reason})`
        );
        continue;
    }

    // intenta agregar el paquete (los 2 juntos)
    try {
      const res = await addTwoAsBundle(bottleId, closureId);

      // Si Shopify responde error, lo consideramos como paquete fallido
      if (!res.ok) {
        removed.push(
            `- 1 bundle "${bottleTitle}" + "${closureTitle}" was removed (Shopify did not allow it to be added)`
        );
        continue;
      }

      // éxito: incrementa contadores (esto asegura no pasarte de lo permitido)
      addedByVariant[bottleId] = bottleAdded + 1;
      addedByVariant[closureId] = closureAdded + 1;
    } catch (e) {
        removed.push(
            `- 1 bundle "${bottleTitle}" + "${closureTitle}" was removed (network error)`
        );

    }
  }

  // ---------- 3) Mensaje de lo eliminado ----------
  if (removed.length) {
    alert("Some bundles were removed or adjusted:\n\n" + removed.join("\n"));
  }

  window.location.href = "/cart";
}



function toggleMobileClass() {
  const isMobile = $(window).width() < 950;

  $('.custom-bundles__content__right').toggleClass('mobile', isMobile);
}

function scrollToTopIfActive() {
  const $el = $('.custom-bundles__content__right.mobile.active');

  if ($el.length) {
    $el.scrollTop(0);
  }
}

$(function(){

    toggleMobileClass();

    $('.img-tooltip').tooltip({
        trigger: 'hover click',
        container: 'body'
    });

    $(document).on("click", ".custom-select-button.api", function(){
        let currElement = $(this);
        $(".custom-select-button.api").removeClass("active");
        getAllData(currElement.attr("data-id"), null);
        currElement.addClass("active");
    });

    $(document).on("click", ".octo-option-item-color", function(){
        let currElement = $(this);
        $(".octo-option-item-color").removeClass("octo-selected-color");
        getAllDataChange(currDataFull, currElement.attr("data-color"));
        currElement.addClass("octo-selected-color");
    });

    $(document).on("click", ".octo-option-item-size", function(){
        let currElement = $(this);
        $(".octo-option-item-size").removeClass("active");
        getAllDataChangeSize(currDataFull, $(".step-custom__content__product__details__current-color").text(), currElement.attr("data-size"));
        currElement.addClass("active");
    });

    $(document).on("click", ".custom-select-button.type", function(){
        let currElement = $(this);
        $(".custom-select-button.type").removeClass("active");
        getAllDataChangeType(productSelected[0].accesories, currElement.attr("data-type"));
        currElement.addClass("active");
    });

    $(document).on("click", ".custom-bundles__content__right__add-bundle__content", function(){
        let currentClasses = $(this).attr('class');
        if($(this).hasClass('bottle')){
            $('html, body').animate({
                scrollTop: $(".step-custom.step2").offset().top
            }, 600);
        }else if($(this).hasClass('closure')){
            $('html, body').animate({
                scrollTop: $(".step-custom.step4").offset().top
            }, 600);
        }
    });

    $(document).on("click", ".step-custom__content__product__details-add-add:not(.current-added)", function(){
        let el = $(this);

        $(".step-custom__content__product__details-add-add").removeClass("current-added");

        if(productSelected){
            if(productSelected[0].inventory_quantity > 0){
                $(".step-custom__content__product__details-add-add").text('ADD TO BUNDLE');
            }else{
                $(".step-custom__content__product__details-add-add").text('OUT OF STOCK');
            }
        }else{
            $(".step-custom__content__product__details-add-add").text('ADD TO BUNDLE');
        }

        $(".custom-bundles__content__right__add-bundle__content.bottle").removeClass("no-selected");
        $(".custom-bundles__content__right__add-bundle__content.bottle").attr("data-image", productSelected[0].feature_image_url);
        $(".custom-bundles__content__right__add-bundle__content.bottle").attr("data-name", productSelected[0].name);
        $(".custom-bundles__content__right__add-bundle__content.bottle").attr("data-price", productSelected[0].price);
        $(".custom-bundles__content__right__add-bundle__content.bottle").attr("data-varint-id", productSelected[0].variant_id);
        $(".custom-bundles__content__right__add-bundle__content.bottle img").attr("src", productSelected[0].feature_image_url);
        $(".custom-bundles__content__right__add-bundle__content.bottle p").text(`BOTTLE`);
        $(".custom-bundles__content__right__add-bundle__content.bottle > div div").text(`${productSelected[0].name} ${productSelected[0].product_title_complement}`);
        $(".custom-bundles__content__right__add-bundle__content.bottle span").text(`$${productSelected[0].price} Value`);
        calculatePricesPreBundle();
        el.text("ADDED TO BUNDLE");
        el.addClass("current-added");
    });

    $(document).on("click", ".step-custom__content__product__details-add-add-accesorie:not(.current-added)", function(){
        let el = $(this);
        let curenVariantId = el.attr("data-variant-id");

        $(".step-custom__content__product__details-add-add-accesorie").removeClass("current-added");
        $(".step-custom__content__product__details-add-add-accesorie:not(:disabled)").text("ADD TO BUNDLE");
        
        const filteredItem = productSelected[0].accesories.filter(
            item => item.variant_id == curenVariantId
        );
        
        $(".custom-bundles__content__right__add-bundle__content.closure").removeClass("no-selected");
        $(".custom-bundles__content__right__add-bundle__content.closure").attr("data-image", filteredItem[0].image_src);
        $(".custom-bundles__content__right__add-bundle__content.closure").attr("data-name", filteredItem[0].title);
        $(".custom-bundles__content__right__add-bundle__content.closure").attr("data-price", filteredItem[0].price);
        $(".custom-bundles__content__right__add-bundle__content.closure").attr("data-varint-id", filteredItem[0].variant_id);
        $(".custom-bundles__content__right__add-bundle__content.closure img").attr("src", filteredItem[0].image_src);
        $(".custom-bundles__content__right__add-bundle__content.closure p").text(`CLOSURE`);
        $(".custom-bundles__content__right__add-bundle__content.closure > div div").text(`${filteredItem[0].title}`);
        $(".custom-bundles__content__right__add-bundle__content.closure span").text(`$${filteredItem[0].price} Value`);
        calculatePricesPreBundle();
        el.text("ADDED TO BUNDLE");
        el.addClass("current-added");
       
    });

    $(document).on("click", ".custom-button-add-to-bundle", function(){
        let countItems = 0
        $('.custom-bundles__content__right__add-bundle__content').each(function (index) {
            if(Number($(this).attr("data-price"))){
                countItems++;
            }
        });

        if(countItems == 2){
            let currBottle = {};
            let currClosure  = {};
            $('.custom-bundles__content__right__add-bundle__content').each(function (index){
                if (index === 0) {
                    currBottle = {
                        img: $(this).attr("data-image"),
                        title: $(this).attr("data-name"),
                        price: $(this).attr("data-price"),
                        variant_id: $(this).attr("data-varint-id"),
                    };
                }
                if (index === 1) {
                    currClosure  = {
                        img: $(this).attr("data-image"),
                        title: $(this).attr("data-name"),
                        price: $(this).attr("data-price"),
                        variant_id: $(this).attr("data-varint-id"),
                    };
                }
            });

            currntBundlesCreated.unshift({
                currBottle, currClosure
            });
        }

        updateItems("add");
       
    });

    $(document).on("click", ".remove-bundle-from-cart", function(){
        let el = $(this);
        let currIndex = el.attr("data-index");
        currntBundlesCreated.splice(currIndex, 1);
        updateItems("remove");
    });

    $(document).on("click", ".create-new-bundle", function(e){
        e.preventDefault();
        $(".custom-bundles__content__right.mobile").removeClass("active");
    });

    $(document).on("click", ".view-my-bundles", function(e){
        e.preventDefault();
        let el = $(this);
        $(".custom-bundles__content__right.mobile").toggleClass("active");
        if($(".custom-bundles__content__right.mobile").hasClass("active")){
            setTimeout(scrollToTopIfActive, 50);
            el.text("Create new bundle");
        }else{
            el.text("View my bundles");
        }
        
    });

    $(document).on("click", ".custom-bundles__footer > a", function(e){
        e.preventDefault();
        addBundlesToCartAndGo(currntBundlesCreated);
    });
    

    $(".step-custom__content__selects .custom-select-button:first-child").trigger("click");

    $(".custom-bundles__content__right__subtitle span").text(discountBlocksCount - numBundles);

    $(".custom-bundles__content__right__title span").text(numBundles);
    
    $(window).on('resize', function () {
        toggleMobileClass();
    });

});